export default __webpack_public_path__ + "static/media/poster4.7880d068.jpg";